/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionPlusIcon20Solid = forwardRef('TextActionPlusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M4 8a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H4Z" }),
        React.createElement("path", { d: "M4 12a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H4Z" }),
        React.createElement("path", { d: "M16 12a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z" })));
});
